import React from 'react';

import {
  Container,
  Content,
  FilterList,
  Filter,
  FilterText,
  FilterCard,
  FilterBadge,
  FilterBadgeText,
  FilterRow,
  FilterSubtitle,
  Icon,
  Footer,
} from './styles';
import {Header} from '../../../../components/Interface/Headers/Header';
import {useNavigation, useRoute} from '@react-navigation/native';

import {Titles} from '../../../../components/Interface/Typographies/Titles';

import {Button} from '../../../../components/Interface/Forms/Buttons/Button';
import {SafeAreaView} from 'react-native-safe-area-context';

interface Params {
  categoria: string;
  cidade: number;
  bairro: number;
  estado: number;
}

export function StoreSearchFilters() {
  const navigation = useNavigation();
  const route = useRoute();

  const {bairro, cidade, estado, categoria} = route.params as Params;

  function handleNavigate() {
    navigation.navigate({
      name: 'StoreSearch',
      params: {
        estado,
        cidade: estado ? cidade : undefined,
        bairro: estado && cidade ? bairro : undefined,
        categoria,
      },
      merge: true,
    });
  }

  return (
    <Container>
      <Header icon="chevron-left" action={() => navigation.goBack()} />

      <Content>
        <Titles
          title="Filtrar parceiros"
          subtitle="Combine filtros para resultados mais precisos."
        />

        <FilterList>
          <FilterCard>
            <Filter
              activeOpacity={1}
              onPress={() =>
                navigation.navigate('StoreFiltersState', {estado})
              }>
              <FilterRow>
                <FilterText>Estado</FilterText>
                {estado && (
                  <FilterBadge>
                    <FilterBadgeText>1 selecionado</FilterBadgeText>
                  </FilterBadge>
                )}
              </FilterRow>
              <Icon name="chevron-right" />
            </Filter>
            {estado && (
              <Filter
                activeOpacity={1}
                onPress={() =>
                  navigation.navigate('StoreFiltersCities', {estado, cidade})
                }>
                <FilterRow>
                  <FilterText>Cidade</FilterText>
                  {cidade && (
                    <FilterBadge>
                      <FilterBadgeText>1 selecionado</FilterBadgeText>
                    </FilterBadge>
                  )}
                </FilterRow>
                <Icon name="chevron-right" />
              </Filter>
            )}

            {estado && cidade && (
              <Filter
                activeOpacity={1}
                onPress={() =>
                  navigation.navigate('StoreFiltersNeighborhood', {
                    cidade,
                    bairro,
                  })
                }>
                <FilterRow>
                  <FilterText>Bairro</FilterText>
                  {bairro && (
                    <FilterBadge>
                      <FilterBadgeText>1 selecionado</FilterBadgeText>
                    </FilterBadge>
                  )}
                </FilterRow>
                <Icon name="chevron-right" />
              </Filter>
            )}

            <Filter
              activeOpacity={1}
              onPress={() =>
                navigation.navigate('StoreFiltersCategory', {categoria})
              }
              style={{borderBottomWidth: 0}}>
              <FilterRow>
                <FilterText>Categoria</FilterText>
                {categoria && (
                  <FilterBadge>
                    <FilterBadgeText>1 selecionada</FilterBadgeText>
                  </FilterBadge>
                )}
              </FilterRow>
              <Icon name="chevron-right" />
            </Filter>
          </FilterCard>

  
        </FilterList>
      </Content>
      <Footer>
        <SafeAreaView>
          <Button
            title="Aplicar filtros"
            enabled={categoria !== undefined || estado !== undefined}
            onPress={handleNavigate}
          />
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
